import React from 'react';
import { Trans } from 'react-i18next';
import { keyMap } from '@locales/lokalise/keyMap';
import { useSupportEmail } from '@utils/hooks/useSupportEmail';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';

export const TradingPlatformHint = observer(() => {
  const {
    accountStore: {
      generalSettings: { brokerParams },
    },
  } = useMobxStore();

  const { clientSupportEmail } = useSupportEmail(brokerParams);

  const message = "Sorry, Master's account is hidden. Please contact your Master or";

  return (
    <div>
      <Trans values={{ address: clientSupportEmail }} i18nKey={keyMap.accountPlatformHint}>
        {message}
        <a style={{ display: 'inline' }} rel="noreferrer" href={`mailto:${clientSupportEmail}`}>
          {clientSupportEmail}
        </a>
      </Trans>
    </div>
  );
});
